import { Building2, Check, ChevronsUpDown } from "lucide-react";
import { toast } from "sonner";
import { useSession } from "@/context/SessionContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { errMsg } from "@/lib/api";

export const BusinessSwitcher = () => {
  const { session, switchOrg } = useSession();
  const tenants = session.tenant?.tenants || [];
  const name = session.tenant?.name || session.tenant?.org_name || session.org_id;

  const label = (
    <span className="flex items-center gap-2 min-w-0">
      <Building2 className="h-4 w-4 text-slate-500 shrink-0" />
      <span className="font-display font-semibold truncate" data-testid="active-business-name">{name}</span>
    </span>
  );
  if (tenants.length <= 1) return label;

  const pick = async (id) => {
    try {
      await switchOrg(id);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger data-testid="business-switcher-trigger" className="flex items-center gap-2 px-3 py-1.5 rounded-md border border-slate-200 hover:border-slate-400 transition-colors duration-150 max-w-xs">
        {label}
        <ChevronsUpDown className="h-3.5 w-3.5 text-slate-400" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        <DropdownMenuLabel className="text-xs uppercase tracking-wider text-slate-500">Businesses</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {tenants.map((t) => (
          <DropdownMenuItem key={t.org_id} data-testid={`business-option-${t.org_id}`} onClick={() => pick(t.org_id)} className="flex justify-between">
            <span className="truncate">{t.name || t.org_id}</span>
            {t.org_id === session.org_id && <Check className="h-4 w-4 text-blue-600" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
